import React, { useState, useEffect, useRef } from "react"
import { Message } from "../../km"
import TwoOptionsDialog from "src/sites/file/TwoOptionsDialog"
import CustomTextarea from "src/sites/text/CustomTextarea"

const ThumbsPopup = ({
  isOpen,
  onRequestClose,
  onSubmitComment,
  message
}: {
  isOpen: boolean
  onRequestClose: (message: Message | null) => void
  onSubmitComment: (comment: string, message: Message | null) => void
  message: Message | null
}) => {
  const [comment, setComment] = useState(message?.comment || "")
  const textAreaRef = useRef<HTMLTextAreaElement>(null)

  const handleOkClick = () => {
    onSubmitComment(comment, message)
  }

  const handleCancelClick = () => {
    onRequestClose(message)
  }

  useEffect(() => {
    if (isOpen) {
      // Small delay to ensure the dialog is fully rendered before focusing
      const timeoutId = setTimeout(() => {
        textAreaRef.current?.focus()
      }, 100)
      return () => clearTimeout(timeoutId)
    }
    setComment(message?.comment || "")
  }, [isOpen, message]) // Dependency array includes isOpen so this only runs when its value changes

  return (
    <TwoOptionsDialog
      open={isOpen}
      color="primary"
      title={"Leave a Comment"}
      content={
        <CustomTextarea
          inputRef={textAreaRef} // Attach the ref to the textarea
          rows={12}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Type your comment here..."
        />
      }
      firstOptionText={"OK"}
      secondOptionText={"Cancel"}
      firstOptionAction={handleOkClick}
      secondOptionAction={handleCancelClick}
      sizeForMobile="small"
    />
  )
}

export default ThumbsPopup
